import {createAction} from 'typesafe-actions';

import * as Types from './types';

export const setCustomRunColor = createAction(
  '@view/customRunColors/setCustomRunColor',
  action => (ref: Types.Ref, id: string, color: string) =>
    action({ref, id, color})
);
